import { AppThunk } from "@Store/index";
import {
  fetchAmberPlusCrossPageDataIfNeeded,
  setAmberPlusCrossMeta,
} from "./amberPlusCrossReducer";

const loadData = (props: any): AppThunk[] => [
  // Loads partners (and services placeholder) into the AmberPlusCross slice during SSR.
  fetchAmberPlusCrossPageDataIfNeeded(),
  setAmberPlusCrossMeta(props?.params?.service, props?.req?.url),
];

export default loadData;
